import BasePropertyView from 'BasePropertyView.js';
import listService from 'ListService.js';
import formatTemplate from 'properties/main/caption.ejs';
import util from 'util/Util.js';
import constants from 'Constants';
import undoService from 'UndoService';
import mobileSyncService from "../../../service/mobile/MobileSyncService";
import textUtil from 'util/TextUtil.js';
class MainCaptionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]'       : 'updateAttributes',
            'change textarea'               : 'updateAttributes',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'change input[type=checkbox]'   : 'updateCheckAttributes'
        };

        // Add needed property
        if (!this.model.get('text')) {
            this.model.set('text', '', {silent: true});
        }
        let isSourceMultiBranch = false;
        if (this.model.get('srcWidgetModel')) {
            isSourceMultiBranch = this.model.get('srcWidgetModel').attributes.factoryKey === 'command_multiple_branch';
        }
        this.model.set('isSourceMultiBranch',isSourceMultiBranch, constants.MODEL_SILENT);

        this.model.set('mainKind', listService.mainKind, constants.MODEL_SILENT);

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldVal=this.model.get(propName);

        if(propName === "text"){
            textUtil.adjustTextWidth(this.model, propVal);
        }

        this.model.set( propName, propVal,constants.MODEL_SILENT );
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        if (this.model.get('factoryKey') === 'connection_arrow') {
            this.addUndoRedoAction(propName,oldVal,propVal);
            listService.fcanvas.renderAll();
        }else{
            this.model.trigger('change');
        }
        
    }

    addUndoRedoAction(propName,oldValue,newValue){
        undoService.add({
            undo:() => {
                this.model.set(propName, oldValue,constants.MODEL_SILENT);
                if(this.model.get('factoryKey') === 'connection_arrow'){
                    listService.fcanvas.renderAll();
                }else{
                    this.model.trigger('change');
                }
                
               
            },
            redo: () => {
                this.model.set(propName, newValue,constants.MODEL_SILENT);
                if(this.model.get('factoryKey') === 'connection_arrow'){
                    listService.fcanvas.renderAll();
                }else{
                    this.model.trigger('change');
                }
            }
        })
    }
    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        if (this.model.get('factoryKey') === 'connection_arrow') {
            listService.fcanvas.renderAll();
        }
    }

    render() {
        this.$el.empty();


        this.model.set({'autoSummaryAreaState': '', 'autosummaryChecked': ''}, {silent: true});

        let bAutoSummary = util.isTrue(this.model.get('autosummary'));
        if (bAutoSummary) {
            this.model.set({'autoSummaryAreaState': 'disabled', 'autosummaryChecked': 'checked'}, {silent: true});
        }

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.addMultilanguageIcon();
        
        this.delegateEvents();
        return this;
    }

}

export default MainCaptionView;
